import { InjectionToken, Type } from '@angular/core';

/**
 * We use this token so we can inject any extra controls component to be rendered onto the territory map or just map in general
 *
 * @remarks
 * **ONLY** in the `leaflet` map not the `google maps`
 */
export const MAP_CUSTOM_CONTROLS = new InjectionToken<Type<any>>('MAP_CUSTOM_CONTROLS');
